import Basic from "./Basic";
import PageLeave from "./PageLeave";

export default {
  Basic,
  PageLeave
};